import { render } from "./Contributions.vue?vue&type=template&id=50ebe916&scoped=true"
import script from "./Contributions.vue?vue&type=script&lang=js"
export * from "./Contributions.vue?vue&type=script&lang=js"

import "./Contributions.vue?vue&type=style&index=0&id=50ebe916&scoped=true&lang=css"

import exportComponent from "/home/acartia-ops/acartia/src/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ebe916"]])

export default __exports__